import _objectSpread from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

var removeOldestQuery = function removeOldestQuery(_ref) {
  var persistedClient = _ref.persistedClient;

  var mutations = _toConsumableArray(persistedClient.clientState.mutations);

  var queries = _toConsumableArray(persistedClient.clientState.queries);

  var client = _objectSpread(_objectSpread({}, persistedClient), {}, {
    clientState: {
      mutations: mutations,
      queries: queries
    }
  }); // sort queries by dataUpdatedAt (oldest first)


  var sortedQueries = _toConsumableArray(queries).sort(function (a, b) {
    return a.state.dataUpdatedAt - b.state.dataUpdatedAt;
  }); // clean oldest query


  if (sortedQueries.length > 0) {
    var oldestData = sortedQueries.shift();
    client.clientState.queries = queries.filter(function (q) {
      return q !== oldestData;
    });
    return client;
  }

  return undefined;
};

export { removeOldestQuery };